import HttpServices from './HttpServices';


export default class InstagramServices {
	HttpServices: HttpServices;
	BO_API_URL: string;
	accountId: string;

	constructor(accountId: string, $http: any) {
		this.HttpServices = new HttpServices($http);
		if (!window || !(window as any).BEYABLE_env || !(window as any).BEYABLE_env.BO_API_URL) {
			throw 'Configuration [window.BEYABLE_env.BO_API_URL] missing';
		}
		else {
			this.BO_API_URL = `${(window as any).BEYABLE_env.BO_API_URL}`;
		}
		this.accountId = accountId;
	}


	getToken(
		callbackSuccess: (response: InstagramToken) => void,
		callbackNotFound: () => void,
		callbackError: (error: any, result?: any) => void
	): void {
		this.HttpServices.get(`${this.BO_API_URL}account/${this.accountId}/accesstokens/instagram`, callbackSuccess, (error, result) => {
			if (result.status === 404) {
				callbackNotFound();
			} else {
				callbackError(error, result);
			}
		});
	}

	saveToken(
		token: InstagramToken,
		callbackSuccess: () => void,
		callbackError: (error: any, result?: any) => void
	): void {
		this.HttpServices.post(`${this.BO_API_URL}account/${this.accountId}/accesstokens/instagram`, token, callbackSuccess, callbackError);
	}

	getMediaPage(
		previousPageCursor: string | null,
		nextPageCursor: string | null,
		callbackSuccess: (page: InstagramResponse) => void,
		callbackError: (error: any, result?: any) => void
	): void {
		this.HttpServices.get(`${this.BO_API_URL}instagrammedialibrary/${this.accountId}?previousPageCursor=${previousPageCursor ?? ''}&nextPageCursor=${nextPageCursor ?? ''}`, callbackSuccess, callbackError);
	}

	getMediaContent(
		mediaId: string,
		callbackSuccess: (data: InstagramMediaContentData) => void,
		callbackError: (error: any, result?: any) => void
	): void {
		this.HttpServices.get(`${this.BO_API_URL}instagrammedialibrary/${this.accountId}/${mediaId}`, callbackSuccess, callbackError);
	}


	postAccounAccessToken(accessToken, callbackSuccess, callbackError) {
		const url = `${this.BO_API_URL}account/${this.accountId}/accesstokens/instagram`;
		const body = JSON.stringify(accessToken);
		this.HttpServices.post(url, body, callbackSuccess, callbackError);
	}
	getAccountAccessToken(callbackSuccess, callbackError) {
		const url = `${this.BO_API_URL}account/${this.accountId}/accesstokens/instagram`;
		this.HttpServices.get(url, callbackSuccess, callbackError);
	}
}

export type InstagramToken = {
	token: string;
}

export type InstagramResponse = {
	data?: InstagramMediaContentData[];
	paging?: InstagramMediaPagingInfo;
}

type InstagramMediaPagingInfo = {
	cursors?: {
		before?: string;
		after?: string;
	};
}


export type InstagramMediaContentData = {
	id?: string;
	media_url?: string;
	permalink?: string;
	media_type?: string;
	thumbnail_url?: string;
	children?: {
		data?: InstagramMediaContentData[]
	};
}

